import { Bot, GraduationCap, Library, PenTool } from 'lucide-react';

import { FeatureCard } from '../../components/FeatureCard';
import { SectionWrapper } from '../../components/SectionWrapper';

import styles from './HumanitiesBuildSection.module.css';

const offerings = [
  {
    body: 'We partner with university faculty to develop courses that incorporate AI directly into the learning process. Students engage with course-specific AI systems designed to support writing, discussion, analysis, and intellectual exploration — grounded in the goals of the discipline and the vision of the instructor.',
    icon: GraduationCap,
    title: 'AI-Integrated Courses',
  },
  {
    body: 'Kai Coach is Kudu Humanities’ AI learning coach. Unlike general-purpose AI tools, it is built around course-specific materials, instructor goals, and pedagogical frameworks. It functions as a learning companion: students ask questions, explore concepts, receive guidance on writing, and engage in iterative conversations that encourage deeper understanding rather than simple answer retrieval. The goal is not assignment completion — it is helping students become more confident, independent thinkers.',
    icon: Bot,
    title: 'Kai Coach',
  },
  {
    body: 'A central innovation of Kudu Humanities is AI that operates within carefully curated educational environments. Our systems draw directly from course-specific materials — lectures, textbooks, primary sources, assignments, and instructor guidance — to provide responses grounded in the intellectual framework of a particular course. Students receive support that is contextually relevant, academically aligned, and faithful to the learning objectives their faculty have established.',
    icon: Library,
    title: 'Contextual AI Grounded in Academic Materials',
  },
  {
    body: 'We create textbooks, learning materials, writing guides, and digital resources tailored to individual instructors and courses — combining academic rigor with accessible design and genuine pedagogical purpose.',
    icon: PenTool,
    title: 'Custom Educational Content',
  },
] as const;

export function HumanitiesBuildSection() {
  return (
    <SectionWrapper background="soft" data-testid="humanities-section-build">
      <div className={styles.section}>
        <div className={styles.header}>
          <p className={styles.eyebrow}>WHAT WE BUILD</p>
          <h2 className={styles.title}>
            Faculty expertise, designed pedagogy, and contextual AI
          </h2>
          <p className={styles.subhead}>
            We build the courses, tools, and materials that let humanities
            classrooms use AI without losing what makes them rigorous and human.
          </p>
        </div>

        <div className={styles.grid}>
          {offerings.map((offering) => (
            <FeatureCard key={offering.title} {...offering} />
          ))}
        </div>
      </div>
    </SectionWrapper>
  );
}
